import { io } from "socket.io-client";

const socket = io("https://techservicemarket-backend.onrender.com", {
    reconnection: true,            // Enable reconnection
    reconnectionAttempts: Infinity,       // Maximum number of reconnection attempts
    reconnectionDelay: 1000,       // Delay before first reconnection attempt (ms)
    reconnectionDelayMax: 5000,    // Maximum delay between reconnection attempts (ms)
    randomizationFactor: 0.5,      // Randomization factor for the delay
  });
  
// Event when the client successfully connects
socket.on("connect", () => {
console.log("Successfully connected to the server.");
});

// Event when the client gets disconnected
socket.on("disconnect", () => {
console.log("Disconnected from the server.");
});

// Event when a reconnection attempt is made
socket.on("reconnect_attempt", () => {
console.log("Reconnecting...");
});

// Event when reconnection fails
socket.on("reconnect_error", (error) => {
console.log("Reconnection failed:", error);
});

// Event when all reconnection attempts fail
socket.on("reconnect_failed", () => {
console.log("Reconnection attempts failed.");
});

// Event when a message is received
socket.on("receiveMessage", (messageData) => {
console.log("Received message:", messageData);
});
  

export default socket;